import React from 'react';
import PropTypes from 'prop-types';
import { SpinnerStyled } from './styles';

class MainSpinner extends React.PureComponent {
  render() {
    const { spinnerState } = this.props;
    if (!spinnerState) return null;
    return (
      <SpinnerStyled>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </SpinnerStyled>
    );
  }
}

MainSpinner.defaultProps = {
  spinnerState: true,
};

MainSpinner.propTypes = {
  spinnerState: PropTypes.bool,
};

export default MainSpinner;
